// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"a0_e","footer":"a0_a0","link":"a0_ae","logo":"a0_co","links":"a0_bx","logos":"a0_cq","inner":"a0_au"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 7